import * as types from '../../actions/ActionTypes.js';
import { parseWorkoutSegments } from 'utils/workout/WorkoutUtil.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: {},
    lastUpdated: null
};

const requestWorkoutSchedule = (state) => ({
    ...state,
    isFetching: true
});

const receiveWorkoutSchedule = (state, action) => {
    const updatedWorkoutSegments =
        action.data && action.data.workout && action.data.workout.workoutSegments
            ? parseWorkoutSegments(action.data.workout.workoutSegments)
            : [];

    const workoutSchedule = {
        ...action.data,
        workout: {
            ...action.data.workout,
            workoutSegments: updatedWorkoutSegments
        }
    };

    return {
        ...state,
        entities: workoutSchedule,
        isFetching: false,
        lastUpdated: action.receivedAt
    };
};

const updateWorkoutScheduleDateSuccess = (state, action) => {
    const { workoutSchedule } = action;

    return {
        ...state,
        entities: {
            [workoutSchedule.workoutScheduleId]: workoutSchedule
        },
        lastUpdated: action.receivedAt
    };
};

const handlers = {
    [types.REQUEST_WORKOUT_SCHEDULE]: requestWorkoutSchedule,
    [types.RECEIVE_WORKOUT_SCHEDULE]: receiveWorkoutSchedule,
    [types.UPDATE_WORKOUT_SCHEDULE_DATE_SUCCESS]: updateWorkoutScheduleDateSuccess
};

export const getWorkoutSchedule = (state) => {
    return state.workoutSchedule;
};

export default function workoutSchedule(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function updateWorkoutScheduleDate(params) {
    return {
        type: types.UPDATE_WORKOUT_SCHEDULE_DATE,
        payload: {
            workoutScheduleId: params.workoutScheduleId,
            calendarDate: params.calendarDate,
            workoutScheduleDTO: params.workoutScheduleDTO
        }
    };
}
